import React from "react";
import { Button } from "react-bootstrap";

export default function ExternalLinkButton({ title, url }) {
  const openInNewTab = () => {
    window.open(url, "_blank", "noopener,noreferrer");
  };
  
  return (
    <div className="float-right">
      <Button title={title} onClick={openInNewTab} variant="info" size="md" className="text-info btn-link edit">
        <i className="fa fa-link text-blueGray-500" />
      </Button>
    </div>
  );
}